import * as React from 'react';
import { EditIcon, EntityCard } from '@ui/components';

import './CollectionCard.less';
import { Modal } from 'antd';
import collectionPng from '@ui/assets/collection.png';
import { getApiUrl } from '../../../../utils/config';

interface Props {
  collection: any;
  removeCollection: (collectionId: string) => void;
  onClickEdit: (collection: any) => void;
}

class CollectionCard extends React.PureComponent<Props> {
  state = {
    isOpenRemove: false,
  };

  handleChangeRemoveState = (isOpenRemove: boolean) => {
    this.setState({ isOpenRemove });
  };

  handleRemoveCollection = () => {
    const {
      collection: { id },
      removeCollection,
    } = this.props;

    this.handleChangeRemoveState(false);
    removeCollection(id.toString());
  };

  render() {
    const { collection, onClickEdit } = this.props;

    const { isOpenRemove } = this.state;

    return (
      <EntityCard>
        <div className="collection-card">
          <div className="collection-card-panel">
            <div className="collection-card-panel__photo">
              {collection.photo ? (
                <img
                  src={`${getApiUrl()}/collection/${
                    collection.id
                  }/get-photo`}
                  width="180px"
                  height="130px"
                  alt=""
                />
              ) : (
                <img src={collectionPng} width="180px" height="130px" alt="" />
              )}
            </div>
            <div className="collection-card-panel__info">
              <div className="collection-card-panel__info__name">
                <span>{collection.name}</span>
              </div>
              <div className="collection-card-panel__info__vendor">
                <span>Арт:</span> <span>{collection.vendorCode}</span>
              </div>
            </div>
          </div>
          <div className="collection-card-edit">
            <EditIcon type="edit" onClick={() => onClickEdit(collection)} />
            <EditIcon
              type="remove"
              onClick={() => this.handleChangeRemoveState(true)}
            />
          </div>
          <Modal
            okButtonProps={{
              style: {
                width: '120px',
              },
              size: 'large',
              type: 'danger',
            }}
            cancelButtonProps={{
              style: {
                width: '120px',
              },
              size: 'large',
              type: 'primary',
            }}
            okText="Да"
            cancelText="Нет"
            title="удаление коллекции"
            visible={isOpenRemove}
            onOk={this.handleRemoveCollection}
            onCancel={() => this.handleChangeRemoveState(false)}
          >
            <p>Вы уверены, что ходите удалить?</p>
            <p>Коллекцию</p>
            <p style={{ fontSize: '16px' }}>{name}</p>
          </Modal>
        </div>
      </EntityCard>
    );
  }
}

export default CollectionCard;



// WEBPACK FOOTER //
// ./src/scenes/Collections/components/CollectionCard/CollectionCard.tsx